export * from "./about";
export * from "./ctas";
export * from "./footers";
export * from "./forms";
export * from "./header";
export * from "./heroes";
export * from "./inventory";
export * from "./seo";
export * from "./smart-widget";
export * from "./stick-navbar";
export * from "./stick-footer";
export * from "./premium-modules";
export * from "./privacy-policy";
export * from "./floating-whatsapp";
export * from "./opening-hours";
export * from "./navigation";
export * from "./FAQ";
export * from "./pop-up";
